import styled from "styled-components"

import { spacing } from "@minuthq/meatball-ui-react"
import { Text } from "@minuthq/meatball-ui-react"

import { DashboardTodo } from "src/components/Dashboard/DashboardTodos/Todos/DashboardTodo"
import { useGetUser } from "src/data/user/hooks/useGetUser"
import { usePostRequestUserVerificationCode } from "src/data/user/queries/userQueries"
import { useTimer } from "src/hooks/useTimer"
import { useTranslate } from "src/i18n/useTranslate"
import ProfileIcon from "src/ui/icons/profile.svg"
import { MBanner } from "src/ui/MBanner/MBanner"

export function DashboardVerifyEmailTodo() {
  const { t, langKeys } = useTranslate()
  const user = useGetUser()
  const postRequestUserVerificationCode = usePostRequestUserVerificationCode()

  const { timeLeft, startTimer, isTimerRunning } = useTimer()

  function handleClickResendEmail() {
    postRequestUserVerificationCode.mutate(
      { path: { user_id: user.user_id } },
      {
        onSuccess: () => {
          // 60 seconds cooldown timer
          startTimer(60, { onExpire: postRequestUserVerificationCode.reset })
        },
      }
    )
  }

  return (
    <DashboardTodo
      title={t(langKeys.verify_email_todo_title)}
      icon={<ProfileIcon width={24} />}
      buttonLabel={
        t(langKeys.resend_email) + (isTimerRunning ? ` (${timeLeft})` : "")
      }
      buttonProps={{
        onClick: handleClickResendEmail,
        disabled: isTimerRunning,
        loading: postRequestUserVerificationCode.isLoading,
      }}
    >
      <Grid>
        <Text>
          {t(langKeys.verify_email_sent, { email_address: user.email })}
        </Text>

        {postRequestUserVerificationCode.isSuccess && (
          <MBanner type="good" fullWidth>
            {t(langKeys.verify_email_resent)}
          </MBanner>
        )}
      </Grid>
    </DashboardTodo>
  )
}

const Grid = styled.div`
  display: grid;
  gap: ${spacing.M};
`
